import { Module } from 'vuex'
import { PurchaseIntentionState, state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/app/common/types/root-state.type'

export const purchaseIntentionStore: Module<PurchaseIntentionState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
